import { createAction } from 'redux-act'

import { BankTransferState } from '../types'

export const initBankTransfer = createAction('Bank Transfer')

export const fetchBankListStart = createAction('Fetch Banks List')
export const fetchBanksListSuccess = createAction<{ bankInfos: BankTransferState['bankInfos'] }>(
  'Fetch Banks List success',
)
export const fetchBanksListFail = createAction<boolean>('Fetch Banks List fail')

export const setSelectedBankId = createAction<string>('Set selected Bank Id')
export const setErrorState = createAction<boolean>('Set Show Error')

export const showBankSelectionPopup = createAction<boolean>('Show bank selection popup')
